import React from 'react';
import { renderTextWithImages } from './imageFormatter';

const CITE_RE = /(\[\d+\])/g;

/**
 * Parse text for [N] citation markers and return React nodes with
 * clickable superscript elements. Also handles image markdown via
 * renderTextWithImages for non-citation text segments.
 *
 * @param {string} text            Raw text potentially containing [1], [2], etc.
 * @param {Array}  citationIndex   Array of {cite_num, node_id, label, source_doc, pages, reference_text}
 * @param {Function} onCiteClick   (event, citeEntry) => void
 * @param {number} keyOffset       React key offset
 * @returns {React.ReactNode[]}
 */
export function renderTextWithCitations(text, citationIndex, onCiteClick, keyOffset = 0) {
  if (!text) return [text];
  if (!citationIndex?.length) return renderTextWithImages(text, keyOffset);

  const citeLookup = {};
  for (const c of citationIndex) {
    citeLookup[c.cite_num] = c;
  }

  const parts = text.split(CITE_RE);
  const nodes = [];

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (!part) continue;

    const match = part.match(/^\[(\d+)\]$/);
    if (match) {
      const num = parseInt(match[1], 10);
      const cite = citeLookup[num];
      if (cite) {
        nodes.push(
          <sup
            key={`cite-${keyOffset}-${i}`}
            className="cite-link"
            data-cite-num={num}
            onClick={(e) => onCiteClick(e, cite)}
            title={cite.source_doc ? `${cite.source_doc}${cite.pages?.length ? ` p.${cite.pages.join(',')}` : ''}` : `Citation ${num}`}
          >
            [{num}]
          </sup>
        );
        continue;
      }
    }

    const imgNodes = renderTextWithImages(part, keyOffset + i * 100);
    nodes.push(...imgNodes);
  }

  return nodes;
}
